module.exports = __webpack_public_path__ + "static/img/sebastian_pictgrid57_920x845.656c3f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/sebastian_pictgrid57_920x845.jpg
// module id = s325
// module chunks = 0